webpackJsonp([1],{

/***/ 143:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Handles the plp lazy loading and back button functionality
 * Lazy loads the images once window loads.
 * Fixes the correct page position if going back to plp.
 * @module sizeSelectionModal
 */




var PLUGIN_NAME = 'sizeSelectionModal';
var DEFAULTS = {
    sessionName: '',
    loadAfterCallback: function loadAfterCallback() {}
};
/**
 * Merges together all the options and the various conditions in which they
 * can be set.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Immutable version of the options
 */
var mergeOptions = function mergeOptions($el) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var opts = Object.assign({}, DEFAULTS, $el.data(), options);
    return opts;
};

var showConfirmation = function showConfirmation(opts, hasError, $el) {
    var saveSizeConfirmPath = opts.saveSizeConfirmPath;

    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        url: '' + saveSizeConfirmPath,
        triggerOpen: true,
        type: 'notification',
        returnFocus: $el
    });
};

var updateSizeToDb = function updateSizeToDb($el, opts, sizeValue) {
    if (sizeValue) {
        // const {updateSizePath, code} = opts;
        showConfirmation(opts, false, $el);
        // $.ajax({
        //     url: `${updateSizePath}${sizeValue}`,
        //     type: "POST",
        //     success: function (success) {
        //         if (success) {
        //             showConfirmation(opts, false, $el);
        //             if(typeof logEngagementWithDetails === "function") {
        //                 logEngagementWithDetails(window.location.href, 'favorites save your size', 'SaveSize', `size=${sizeValue}, code=${code}`);
        //             }
        //         }
        //     }
        // });
    } else {
        showConfirmation(opts, true, $el);
    }
};

var setUpdateSizeListener = function setUpdateSizeListener($el, opts) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#select-size-form').on('submit', function (evt) {
        evt.preventDefault();
        var $selectedInput = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name="fav-size-selection"]:checked');
        if (!$selectedInput.length) {
            var $selectSizeForm = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
            var $formField = $selectSizeForm.find('.field');
            var $formLegend = $selectSizeForm.find('legend');
            $formField.addClass('is-error');
            $formLegend.attr('aria-labelledby', 'select-size-error').trigger('focus');
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('input[name="fav-size-selection"]').on('change', function () {
                $formField.removeClass('is-error');
                $formLegend.removeAttr('aria-labelledby');
            });
            return;
        }
        var sizeSelected = $selectedInput.val();
        var code = opts.code,
            addToBag = opts.addToBag;
        // $el.html(`<span id="${code}-fav-size-value" data-size="${sizeSelected}">Size: ${sizeSelected}</span>`); // update size copy

        updateSizeToDb($el, opts, sizeSelected);
        if (addToBag === 'true') {
            var $addToBag = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#add-to-bag-' + code);
            if ($addToBag.length) {
                $addToBag.click();
            }
        }
    });
};

var getSizes = function getSizes($el, opts) {
    var sizePath = opts.sizePath;

    opts.addToBag = $el.data('addToBag');
    $el.data('addToBag', 'false');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        url: sizePath,
        triggerOpen: true,
        type: "small",
        addModifierClass: 'modal--toast-sizes',
        returnFocus: $el,
        onComplete: function onComplete() {
            setUpdateSizeListener($el, opts);
        }
    });
};

/**
 * Applies any sort of event handlers for the switchClass.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el, opts) {
    $el.on('click', function (evt) {
        evt.preventDefault();
        getSizes($el, opts);
    });
};

/**
 * Initializes sizeSelectionModal.
 * @param {jQuery} el - targeting the element of the plp list
 * @param {Object} options - Options used for wiring up the sizeSelectionModal
 * @see DEFAULTS
 */
function sizeSelectionModal(el) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
    var opts = mergeOptions($el, options);
    setEventListeners($el, opts);
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, sizeSelectionModal);

/***/ }),

/***/ 145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = showQuickView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


// Code moved from src/scripts/entry-points/shoppingbag/index.js so limiting updates to maintain annotations
function showQuickView(event, codes, sbsrc, carouselType, callback) {
    var requestURL = window.location.href;
    var isMens = window.location.href.indexOf('d=Mens') != -1;
    var dParam = isMens ? 'Mens' : 'Womens';
    var paramObj = {
        codes: codes,
        d: dParam,
        requestUrl: requestURL
    };
    if (sbsrc) {
        paramObj.sbsrc = sbsrc;
    }
    var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param(paramObj);
    var $triggerTarget = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(event.currentTarget);

    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        url: "/fw/ajax/multiItemQuickview.jsp",
        data: data,
        triggerOpen: true,
        returnFocus: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(event.currentTarget),
        onComplete: function onComplete() {
            if (typeof callback === 'function') {
                callback(carouselType, $triggerTarget);
            }
        }
    });
}

/***/ }),

/***/ 155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modules_log_engagement__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__size_selection_modal__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_social_proof__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_quick_view__ = __webpack_require__(145);





var ENGAGEMENT_MODULE = 'shopping_bag';
var WISHLIST_MARKUP_ENDPOINT = "/fw/content/wishlist/sliderMarkup";

function clickTracker(action, code) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__modules_log_engagement__["a" /* default */])(window.location.href, "shopping_bag", action, { code: code });
}

function setupViewShippingOptions() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#viewShippingMethods').click(function (e) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
            url: '/fw/dialog/ShippingMethods.jsp',
            triggerOpen: true,
            type: 'small',
            returnFocus: '#viewShippingMethods'
        });
    });
}

function showBagSyncNotifications() {
    if (!window.rcProps.shoppingBag.showBagNotification) {
        return;
    }

    var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
        notificationsHandled: true,
        fw: true
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
        type: 'POST',
        url: '/r/ajax/GetBagSyncNotifications.jsp',
        data: data,
        success: function success(rtn) {
            var obj = JSON ? JSON.parse(rtn) : __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.parseJSON(rtn);
            if (obj.success) {
                var type = obj.msg4;
                var notificationModalId = '';
                if ('new_customer' === type) {
                    notificationModalId = 'save-shopping-bag-1';
                } else if ('no_previous_items' === type) {
                    notificationModalId = 'save-shopping-bag-2';
                } else if ('return_customer' === type) {
                    notificationModalId = 'save-shopping-bag-3';
                } else if ('return_customer_checkout' === type) {
                    notificationModalId = 'save-shopping-bag-4';
                }

                if (notificationModalId != '') {
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
                        open: notificationModalId,
                        triggerOpen: true,
                        type: 'notification'
                    });
                }
            }
        }
    });
}

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
    loadcarousels();
});

function loadcarousels() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
        type: 'GET',
        url: window.rcProps.shoppingBag.carouselsEndpoint,
        success: function success(data) {
            var $carouselsWrapper = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#carousels-wrapper-optimize").html(data);

            reinitializeWishListCarousel();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".remove_wish_list").click(removeWishListItem);
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-add-on').recsPopOut();
            // lazy loading for images for shopping bag and shopping bag carousels
            // needs to be removed
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-shopping-bag-lazy-img', $carouselsWrapper).lazy({
                bind: 'event',
                effect: 'fadeIn',
                effectTime: 500,
                threshold: 0
            });
        }
    });
}

function reloadShoppingBag(callback, removedItemIndex) {
    var param = "";
    if (typeof removedItemIndex !== "undefined" && removedItemIndex !== -1) {
        param = "?removedItemIndex=" + removedItemIndex;
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-bag-content').load("/fw/ajax/ShoppingBagContent.jsp" + param, function () {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-modal").modal();
        if (typeof callback === 'function') {
            callback();
        }
        bindEvents();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-bag-content').find('.vanish').vanish();
        setupViewShippingOptions();
        updateBagTotals();
        window.rcProps = window.rcProps || {};
        window.rcProps.shoppingBag = window.rcProps.shoppingBag || {};
        if (window.rcProps.shoppingBag.gotoPayPal === true) {
            if (typeof renderPayPal === 'function') {
                renderPayPal();
            }
        }
        window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
        window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
    });
}
function reinitializeWishListCarousel() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel--seven').each(function () {
        var $this = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
        $this.slickSlider({
            lazyLoad: 'progressive',
            slidesToShow: 7,
            slidesToScroll: 7,
            nextArrow: $this.children('.slick-next'),
            prevArrow: $this.children('.slick-prev'),
            responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 6
                }
            }, {
                breakpoint: 768,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5
                }
            }]
        });
    });
}
window.reloadWishListCarousel = function (callback, gridLayout) {
    var layout = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#wishlist-wrapper").data('layout');
    var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
        gridLayout: layout === 'gridLayout'
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
        type: 'GET',
        url: WISHLIST_MARKUP_ENDPOINT,
        data: data,
        cache: false, // required to prevent get cached markup from browser.
        success: function success(rtn) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#wishlist-wrapper").empty().append(rtn);
            if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#wishlist-wrapper").find(".product-recs__copy").length == 0) {
                loadcarousels();
            }
            reinitializeWishListCarousel();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".remove_wish_list").click(removeWishListItem);
            if (typeof callback === 'function') {
                callback();
            }
        }
    });
};

function removeWishListItem(event) {
    event.preventDefault ? event.preventDefault() : event.returnValue = false;

    var data = {
        code: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('code'),
        size: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('size')
    };
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        url: window.rcProps.shoppingBag.wishList.removalUrl,
        data: data,
        triggerOpen: true,
        type: 'small',
        returnFocus: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(event.target)
    });
}

function updateBag(productcode, size, totalval, sectionURL, name, brand, categoryName, price, currencyCode, previousTotal, restoreCallBack) {
    var total = totalval;

    var qtyToAdd = parseInt(total) - previousTotal;

    window.rcProps = window.rcProps || {};
    window.rcProps.ReCAPTCHACallBack = function () {
        window.rcProps.showReCAPTCHA = false;
        window.rcProps.maxLimit = 50;
        updateBag(productcode, size, totalval, sectionURL, name, brand, categoryName, price, currencyCode, previousTotal, restoreCallBack);
    };
    window.rcProps.ReCAPTCHARestore = function () {
        if (typeof restoreCallBack === 'function') {
            restoreCallBack();
        }
    };

    window.addProduct(productcode, size, sectionURL, null, qtyToAdd, function (obj) {
        if (obj) {
            if (obj.success) {
                reloadShoppingBag(function () {
                    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
                        open: "item-qty-update-modal",
                        triggerOpen: true,
                        type: "notification"
                    });
                });
            }
        }
    });
}

function updateBagTotals() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({ url: "/fw/ajax/CartItemCount.jsp", cache: false }).done(function (msg) {
        if (msg.bagCount) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#cart_item_count").text(msg.bagCount);
        }
    });
}

function openAddToBagNotificationModal(carouselType, $triggerTarget) {
    var modelId = 'wishlist-added-modal'; // By default, wish list.
    if (carouselType === 'recently_viewed') {
        modelId = 'recently-viewed-added-modal';
    } else if (carouselType === 'beauty_add_on') {
        modelId = "item-added-modal";
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        open: modelId,
        triggerOpen: true,
        type: 'notification',
        returnFocus: $triggerTarget
    });
}

function addToBagFromCarouselItem(code, size, name, brand, imageUrl, categoryName, brandName, pdpUrl, retailPrice, carouselType) {
    addToBagFromShoppingBag(code, size, name, brand, imageUrl, categoryName, brandName, pdpUrl, retailPrice, function () {
        if (carouselType !== undefined) {
            var logEngagementModule = '';
            if (carouselType === 'recently_viewed') {
                logEngagementModule = 'recently_viewed';
                loadcarousels();
            } else if (carouselType === 'beauty_add_on') {
                logEngagementModule = 'beauty_add_on';
            }
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__modules_log_engagement__["a" /* default */])(window.location.href, logEngagementModule, "move_to_bag");
            openAddToBagNotificationModal(carouselType);
        }
    }, '', carouselType);
}

function addToBagFromWishList(code, size, name, brand, imageUrl, categoryName, brandName, pdpUrl, retailPrice) {
    addToBagFromShoppingBag(code, size, name, brand, imageUrl, categoryName, brandName, pdpUrl, retailPrice, function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__modules_log_engagement__["a" /* default */])(window.location.href, "wish_list", "move_to_bag");
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
            open: "wishlist-added-modal",
            triggerOpen: true,
            type: "notification"
        });
    }, '', 'wish_list');
}

function addToBagFromShoppingBag(code, size, name, brand, imageUrl, categoryName, brandName, pdpUrl, retailPrice, callback, dateAdded, carouselType) {
    addToBagFromShoppingBagWithObject({
        code: code,
        size: size,
        name: name,
        brand: brand, // Seems redundant with `brandName` but leaving as-is since it's existing code
        imageUrl: imageUrl,
        categoryName: categoryName,
        brandName: brandName,
        pdpUrl: pdpUrl,
        retailPrice: retailPrice,
        callbacks: {
            success: callback
        },
        dateAdded: dateAdded,
        sourceParam: 'addToBagFromCartCarousel=' + carouselType
    });
}
function addToBagFromShoppingBagWithObject(obj) {
    var code = obj.code;
    var size = obj.size;
    var name = obj.name;
    var brand = obj.brand;
    var imageUrl = obj.imageUrl;
    var categoryName = obj.categoryName;
    var brandName = obj.brandName;
    var pdpUrl = obj.pdpUrl;
    var dateAdded = obj.dateAdded;
    var callback = obj.callbacks ? obj.callbacks.success : null;
    var retailPrice = obj.retailPrice;
    var cartCount = parseInt(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#cart_item_count").text(), 10);
    window.addProduct(code, size, window.rcProps.shoppingBag.sectionURL, window.rcProps.shoppingBag.sessionID, 1, function () {
        var cartItems = new Array();
        var cartItem = {};
        cartItem.productCode = code;
        cartItem.size = size;
        cartItem.productName = name;
        cartItem.brandName = brand;
        cartItem.images = [imageUrl];
        cartItem.productCategory = categoryName;
        cartItem.brandName = brandName;
        cartItem.url = pdpUrl;
        // cartItem.price = retailPrice;
        cartItems.push(cartItem);

        if (typeof window.insertFacebookAddToCart === 'function') {
            window.insertFacebookAddToCart(code, retailPrice);
        }
        if (typeof window.insertCordialAddToCart === 'function') {
            window.insertCordialAddToCart(cartItems);
        }
        if (typeof window.insertTaboolaAddToCart === 'function') {
            window.insertTaboolaAddToCart("add", code);
        }
        if (cartCount === 0) {
            location.reload(); // init PayPal button since adding to empty state
        } else {
            reloadShoppingBag(callback);
        }
    }, false, true, null, dateAdded, obj);
}

//************** the code below are for wishlist carousel, need to switch to main pdp feo js when we update this carousel with new style guide **************//
//the js below are copied from pdp-main.js

window.moveToWishList = function (code, size, $cartItem) {
    if (typeof $cartItem === "undefined") {
        $cartItem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#shopbag_tbody').find('tr[data-code="' + code + '"][data-size="' + size + '"]');
    }
    var email = window.rcProps.shoppingBag.email;
    if (!email && !window.rcProps.shoppingBag.canGuestsHaveFavorites) {
        var redirectPage = '/fw/ShoppingBag.jsp' + location.search;
        window.location = '/fw/Login.jsp?page=' + encodeURIComponent(redirectPage);
        return;
    }
    var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
        code: code,
        sectionURL: window.rcProps.shoppingBag.sectionURL,
        sessionID: window.rcProps.shoppingBag.sessionID,
        size: size,
        email: email
    });

    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post("/fw/addToWishList.jsp", data, function () {
        if (typeof $cartItem !== "undefined") {
            $cartItem.find(".js-remove-prod").data('no-notification', true);
            removeProductInternal($cartItem.find(".js-remove-prod"), true);
        }
        if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#wishlist-wrapper').length == 0) {
            loadcarousels();
            return;
        }
        var layout = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#wishlist-wrapper").data('layout');
        var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
            gridLayout: layout === 'gridLayout'
        });
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get(WISHLIST_MARKUP_ENDPOINT, data, function (rtn) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#wishlist-wrapper").empty().append(rtn);
            reinitializeWishListCarousel();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".remove_wish_list").click(removeWishListItem);

            __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
                open: "item-wishlist-modal",
                triggerOpen: true,
                type: "notification"
            });
        });

        if (typeof window.insertPageTrack === 'function') {
            window.insertPageTrack(null, false, code);
        }
        if (typeof window.insertCordialUpdateWishList === 'function') {
            window.insertCordialUpdateWishList('add', code);
        }

        if (typeof window.gaUpdateWishList === 'function') {
            window.gaUpdateWishList('add', code);
        }
        if (typeof window.taboolaWishListAction === 'function') {
            window.taboolaWishListAction("add", code);
        }
        var wishlistCountUpdater = new window.WishlistCountUpdater();
        wishlistCountUpdater.updateCount();
    });
};

function updateWishListCount() {
    if (typeof window.WishlistCountUpdater != 'undefined') {
        var wishlistCountUpdater = new window.WishlistCountUpdater();
        wishlistCountUpdater.updateCount(function (count) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#wishlist-wrapper").data("count", count);
        });
    }
}

function bindEvents() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-go-to-referrer').click(function (e) {
        e.preventDefault();
        var target = document.referrer;
        var checkoutPages = ['ShoppingBag', 'ShippingOptions', 'DeliveryOptions', 'PaymentOptions', 'ReviewConfirm'];
        var isCheckout = false;
        if (target) {
            for (var i = 0; i < checkoutPages.length; i++) {
                if (target.indexOf(checkoutPages[i]) > 0) {
                    isCheckout = true;
                    break;
                }
            }
        }
        if (isCheckout && window.rcProps.shoppingBag.defaultReferrer != '') {
            target = window.rcProps.shoppingBag.defaultReferrer;
        }
        window.location = target;
    });

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-remove-prod').click(function (e) {
        e.preventDefault();
        removeProductInternal(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this), false);
        setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-sb-undo-wrapper").fadeOut(function () {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).remove();
            });
        }, 5000);
    });

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-shopping-bag__qty').change(function () {
        var wrapper = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('wrapper'));
        var code = wrapper.data('code');
        var size = wrapper.data('size');
        var oldQty = parseInt(wrapper.data('qty'));
        var newQty = parseInt(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val());
        if (oldQty == newQty) return;
        clickTracker("edit_quantity", code);
        if (newQty == 0) {
            wrapper.find(".js-remove-prod").click();
            return;
        } else {
            if (newQty < oldQty) {
                wrapper.data('qty', parseInt(newQty));
                window.removeProduct(code, size, oldQty - newQty, function () {
                    reloadShoppingBag(function () {
                        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
                            open: "item-qty-update-modal",
                            triggerOpen: true,
                            type: "notification"
                        });
                    });
                });
            } else {
                wrapper.data('qty', parseInt(newQty));
                var sectionURL = wrapper.data('sectionurl');
                var name = wrapper.data('name');
                var brand = wrapper.data('brand');
                var categoryName = wrapper.data('category');
                var price = wrapper.data('price');
                var currencyCode = wrapper.data('currency');

                updateBag(code, size, newQty, sectionURL, name, brand, categoryName, price, currencyCode, oldQty, function () {
                    wrapper.data('qty', parseInt(oldQty));
                    wrapper.find('.shopping-bag__qty').val(oldQty);
                });
            }
        }
    });

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-wishlist-prod').click(function (e) {
        e.preventDefault();
        var $wrapper = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('wrapper'));
        var code = $wrapper.data('code');
        var size = $wrapper.data('size');
        clickTracker("move_to_wishlist", code);
        moveToWishList(code, size, $wrapper);
    });

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-undo-remove-shopping-item-wrapper").on('click', function () {
        var btn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
        if (btn.data('movetowishlist')) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post('/fw/EditWishlist.jsp', __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
                code: btn.data('code'),
                size: btn.data('size')
            }), function () {
                if (typeof window.reloadWishListCarousel === 'function') {
                    window.reloadWishListCarousel();
                }
                addProductToBagAgain(btn);
            });
        } else {
            addProductToBagAgain(btn);
        }
    });
}

function addProductToBagAgain(btn) {
    addToBagFromShoppingBagWithObject({
        code: btn.data('code'),
        size: btn.data('size'),
        name: btn.data('name'),
        brand: btn.data('brand'),
        imageUrl: btn.data('imageUrl'),
        categoryName: btn.data('categoryName'),
        brandName: btn.data('brandName'),
        pdpUrl: btn.data('pdpUrl'),
        retailPrice: btn.data('retailPrice'),
        dateAdded: btn.data('dateAdded'),
        serialNumber: btn.data('serial')
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__modules_log_engagement__["a" /* default */])(window.location.href, ENGAGEMENT_MODULE, 'undo_remove', { code: btn.data('code') });
}
function loadForwardMultipleQuickView(event, codes, sbsrc, carouselType) {
    event.preventDefault();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__modules_quick_view__["a" /* default */])(event, codes, sbsrc, carouselType, quickViewDisplayCallBack);
}

function removeProductInternal($this, movedToWishList) {
    var wrapper = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + $this.data('wrapper'));
    var code = wrapper.data('code');
    var size = wrapper.data('size');
    var serial = wrapper.data('serial');
    clickTracker("remove_item", code);
    var noNotification = $this.data('no-notification');
    var focusIndex;
    var itemRemovedModal = document.getElementById('item-removed-modal'); // test id=931, group A
    if ($this.parents('.item_row').next().is(':visible')) {
        focusIndex = $this.parents('.item_row').index();
    } else {
        focusIndex = $this.parents('.item_row').parent().children('tr:visible:first').index();
    }
    var removedItemIndex = -1;
    removedItemIndex = $this.data('wrapper').substring("item-".length);
    if (typeof window.removeProduct === 'function') {
        window.removeProduct(code, size, null, function (obj) {
            reloadShoppingBag(function () {
                if (!noNotification) {
                    if (itemRemovedModal) {
                        // show notification if test id=931, group A
                        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
                            open: 'item-removed-modal',
                            triggerOpen: true,
                            onClose: function onClose() {
                                if (focusIndex !== undefined) {
                                    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.shopbag_table .item_row').eq(focusIndex).find('.image_wrap a').focus();
                                }
                            }
                        });
                    }
                }
            }, removedItemIndex);
        }, serial, movedToWishList);
    }
}

function quickViewDisplayCallBack(carouselType, $triggerTarget) {
    //attach color box close behavior
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pop_cancel').click(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal.close);

    //disable links on images
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".qvImage").click(function (event) {
        if (event) {
            event.preventDefault ? event.preventDefault() : event.returnValue = false;
        }
    });

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#buy-now-btn-div").hide();

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size_and_fit_link").click(function (event) {
        event.preventDefault ? event.preventDefault() : event.returnValue = false;
        //var url = $("#size_and_fit_link").data("url");
        //var measurements = $("#size_and_fit_link").data("measurements");
        showSizeGuidePopup();
    });

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-btn").click(function (event) {
        event.preventDefault ? event.preventDefault() : event.returnValue = false;

        //get selected size
        var size = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-select option:selected').val();
        if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#product_info").data("onesize")) {
            size = 'all';
        }
        //get selected code
        var code = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#product_info").data("code");
        //update add to bag pop up's size
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#item-added-size").text(size);

        var btn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
        if (btn.hasClass("special-order")) {
            //do special-order
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#cant-find-size-link").click();
        } else if (btn.hasClass("oos")) {
            //do nothing.
        } else {
            //do add to bag
            addToBag(undefined, undefined, carouselType, $triggerTarget);
        }
    });

    //init size selector
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size-select").change(handleSizeSelection);

    //special order
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#cant-find-size-link").click(showNotifyMePopup);

    //wishlist
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-wishlist-link").hide();

    //initialize slideshow
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".productSelector").click(handleProductSelection);
}

function handleSizeSelection(event) {
    //supress default event
    if (event) {
        event.preventDefault ? event.preventDefault() : event.returnValue = false;
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#buy-now-btn-div").hide();

    //handle size related tasks
    var selectedSize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size-select option:selected");
    //set estimaed delivery date
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#est-span").text(selectedSize.data("est-delivery-date"));

    var addToCartButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-btn");
    var oneLeftDiv = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#one-left-div");
    var estimatedDelivery = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#est-p");
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#select-size-error").hide();

    if (selectedSize.data("is-oos")) {
        oneLeftDiv.hide();
        estimatedDelivery.hide();
        if (selectedSize.data("isOnSale") || !selectedSize.data("eligibleForSpecialOrder")) {
            addToCartButton.text("Notify Me");
        } else {
            addToCartButton.text("Notify Me / Special Order");
        }
        addToCartButton.addClass("special-order");
    } else if (selectedSize.data("is-preorder")) {
        estimatedDelivery.show();
        oneLeftDiv.hide();
        addToCartButton.text("Preorder");
        addToCartButton.addClass("preorder");
    } else {
        addToCartButton.removeClass("special-order").removeClass("preorder").removeClass("oos");
        estimatedDelivery.show();
        //
        if (selectedSize.data("is-one-left")) {
            oneLeftDiv.show();
        } else {
            oneLeftDiv.hide();
        }
        addToCartButton.text("Add To Bag");
        // $("#buy-now-btn-div").show();
    }
}

function handleProductSelection(event) {
    if (event) {
        event.preventDefault ? event.preventDefault() : event.returnValue = false;
    }

    //$("#buy-now-btn-div").show();
    var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data();
    var code = data.code;
    //change product info
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#product_info").data("code", data.code);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#product_info").data("onesize", data.oneSize);

    //hide only one in stock message
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#one-left-div").hide();

    //find object that has this code
    for (var i = 0; i < productDataSet.length; i++) {
        var selectedDisplayProductDataObject = productDataSet[i].currentProductData;
        if (data.code == selectedDisplayProductDataObject.code) {
            updateQuickviewForCode(selectedDisplayProductDataObject, productDataSet[i]);
            break;
        }
    }

    //handle quickview
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".qvImage").click(function (event) {
        if (event) {
            event.preventDefault ? event.preventDefault() : event.returnValue = false;
        }
    });
    //add recent viewed track
    addToRecentViewed(code);
}

function updateQuickviewForCode(data, dataSet) {
    //console.log(data);

    //update title
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#qvName").text(data.name);

    //update brand
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#qvBrand").text(data.brand);

    //update price
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#discountPrice").text(data.priceDisplay);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#qvPrice").text(data.retailPriceDisplay);
    //update sale price if item is on sale
    if (data.onSale) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#discountPrice").show();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#priceBox").addClass("sale");
    } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#discountPrice").hide();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#priceBox").removeClass("sale");
    }

    //estimated delivery date
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#est-span").text(data.estimatedDeliveryDate);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#est-span").data("date", data.estimatedDeliveryDate);

    //update images
    //remove current main images
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".qvImage").remove();

    for (var imageCounter = 0; imageCounter < data.images.length; imageCounter++) {
        var imageString = "<a href='#' class='cycle-slide cycle-sentinel qvImage'><img alt='" + data.name + "' src='" + data.images[imageCounter] + "'></a>";
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#qvImageContainer").append(imageString);
    }

    //update color
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#qvColor").text(data.color);

    //update sizes
    //create size select element if doesn't exist (if first item was sold out or one size only
    // it won't have the drop down)
    //if ($("#size-select").length==0)
    //    $("#qvSizeDiv").prepend("<label id='qvSizeLabel'>Size</label><select id='size-select'></select>");
    // /remove current sizes
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size-select").find('option').remove();
    //append sizes for selected item
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size-select").append("<option value=''>Select Size</option>");
    for (var i = 0; i < data.sizes.length; i++) {
        var sizeLabelString = data.sizes[i].size;
        var qtyStatus = data.sizes[i].quantityStatus;
        if (qtyStatus && qtyStatus != "") {
            //show inline qty status for sold out only
            if (qtyStatus == "Sold Out") {
                sizeLabelString += " - OUT OF STOCK";
            }
        }
        var onlyOneFlag = data.sizes[i].quantity == 1 ? true : false;
        var estDelDate = data.estimatedDeliveryDate;
        if (data.sizes[i].preorderDate) {
            estDelDate = data.sizes[i].preorderDate;
        }

        //add options
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size-select").append("<option value='" + data.sizes[i].size + "'" + " data-is-preorder='" + data.sizes[i].preorder + "'" + " data-is-oos='" + data.sizes[i].outOfStock + "'" + " data-is-one-left='" + onlyOneFlag + "'" + " data-eligible-for-special-order='" + data.sizes[i].eligibleForSpecialOrder + "'" + " data-est-delivery-date='" + estDelDate + "'" + " data-is-on-sale='" + data.onSale + "'" + ">" + sizeLabelString + "</option>");
    }

    if (data.isOOS) {
        //sizes
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size-select").hide();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#qvSizeLabel").hide();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#one-size-div").hide();

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#sold-out-div").show();
        if (data.onSale) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-btn").text("Notify Me");
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-btn").addClass("special-order");
        } else {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-btn").text("Notify Me / Special Order");
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-btn").addClass("special-order");
        }
    } else if (data.isOneSize) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size-select").hide();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#sold-out-div").hide();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".select_dropdown").hide();

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#qvSizeLabel").show();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#one-size-div").show();

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-btn").text("Add To Bag");
    } else {
        //preorder or in stock
        if (data.isAllPreOrder) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-btn").text("Preorder");
        } else {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-btn").text("Add To Bag");
        }

        //last one in stock
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#one-size-div").hide();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#sold-out-div").hide();

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".select_dropdown").show();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size-select").show();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#qvSizeLabel").show();
    }

    //size and fit links
    if (data.sizeGuide && data.sizeGuide != "" && data.sizeGuide != "NONE") {
        //show span
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#qvSizeAndFitSpan").show();
        //update size guide data
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size_and_fit_link').data("url", data.sizeGuideUrl);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size_and_fit_link').data("measurements", data.measurementDescription);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size_and_fit_link').data("measuretable", data.measurements);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size_and_fit_link').data("bullets", data.bulletDescription.join());
    } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#qvSizeAndFitSpan").hide();
    }

    //update view full details
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#displayLink").prop("href", data.productDisplayLink);

    //update brands link
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#qvBrand").prop("href", data.brandLink);

    //update color div with code
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".qvOneColor").data("code", data.code);
    //update add to cart button data with code
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-btn").data("code", data.code);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#cant-find-size-link").data("code", data.code);

    //show or hide final sale banner
    if (data.finalSale) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#finalsaleDiv").show();
    } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#finalsaleDiv").hide();
    }

    //update add to cart popup
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#addToBagLink").prop("href", data.productDisplayLink);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#addToBagImage").prop("src", data.images[0]);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#addToBagBrand").text(data.brand);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#addToBagTitle").text(data.name);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#addToBagPrice").text("$" + data.retailPrice);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#addToBagDiscountPrice").text("$" + data.price);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#addToBagColor").text(data.color);

    //update special order elements
    if (data.isSpecialOrderVisible && !data.onSale && !data.isOOS) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#cant-find-size-span").show();
    } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#cant-find-size-span").hide();
    }

    //init can't find size or special order flag
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#cant-find-size-link").data("showSpecialOrder", data.isSpecialOrderVisible);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#cant-find-size-link").data("showBackInStock", data.isBackInStockVisible);
    if (data.onSale) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#cant-find-size-link").data("showSpecialOrder", false);
    }
    insertPageTrackForMultiItemQuickView(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#urlForPageTrack").val(), data.code);
}
window.addToBag = function (size, code, carouselType, $triggerTarget) {
    if (size == undefined) {
        size = getSelectedSize(true);
    }

    var btn;
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-btn").is(":visible")) {
        btn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-btn");
    } else if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-btn-modal").is(":visible")) {
        btn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-btn-modal");
    } else if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-btn-so-modal").is(":visible")) {
        btn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-btn-so-modal");
    } else {
        return;
    }
    if (code == undefined) {
        code = btn.data("code");
    }
    var sectionURL = btn.data("sectionurl");
    var sessionID = btn.data("sessionid");
    if (size == '' || size == undefined || !code) return;
    var cartCount = parseInt(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#cart_item_count").text(), 10);
    var logEngagementModule = 'wish_list';
    if (carouselType === 'recently_viewed') {
        logEngagementModule = 'recently_viewed';
    }

    window.addProduct(code, size, sectionURL, sessionID, 1, function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__modules_log_engagement__["a" /* default */])(window.location.href, logEngagementModule, "move_to_bag");
        if (cartCount === 0) {
            location.reload(); // init PayPal button since adding to empty state
        } else {
            reloadShoppingBag(function () {
                openAddToBagNotificationModal(carouselType, $triggerTarget);
                if (carouselType === 'recently_viewed') {
                    loadcarousels();
                }
            });
        }
    }, false, false, null, null, { sourceParam: 'addToBagFromCartCarousel=' + carouselType });
};

function addToBag(size, code, carouselType, $triggerTarget) {
    window.addToBag(size, code, carouselType, $triggerTarget);
}
function getSelectedSize(showWarning) {
    var size;
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#one-size-div:visible").length > 0 || __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#product_info").data("onesize")) {
        size = 'all';
    } else {
        if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.trim(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size-select option:selected").val())) {
            size = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.trim(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size-select option:selected").val());
        }
    }
    if (!size && showWarning) {
        //no size selected
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#select-size-error").slideDown();
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#select-size-error").hide();
    }
    return size;
}
function showSpecialOrderPopup(event) {
    if (event) {
        event.preventDefault ? event.preventDefault() : event.returnValue = false;
    }

    var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
        code: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("code"),
        dept: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("dept"),
        sectionURL: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("sectionurl"),
        sessionID: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("sessionid"),
        size: getSelectedSize(false)
    });

    var initSpecialOrderPopup = function initSpecialOrderPopup() {
        //bind events here
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#special-order-sizes button").click(clickSpecialOrderSize);

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#special-order-btn").click(submitSpecialOrderOrNotifyMe);
        //$("#special-order-btn").click(submitSpecialOrder);

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".close-popup").click(closePopup);
    };

    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        url: "/fw/dialog/SpecialOrder.jsp",
        data: data,
        scrolling: false,
        triggerOpen: true,
        type: 'small',
        onComplete: function onComplete() {
            if (typeof initSpecialOrderPopup === 'function') {
                initSpecialOrderPopup();
            }
        }
    });
}

var backInStockUtils = function () {
    function submitNotifyMe(object, notifyMeFeatureFromSpecialOrderPage) {
        var data = {};
        var thankyouDivToShow = '';
        var email = '';
        //if notifyme feature is being submitted from special order page, skip validation and
        //fetch size and email from different elements
        if (notifyMeFeatureFromSpecialOrderPage == false) {
            email = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#special-order-email").val();
            data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
                size: __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#special-order-sizes").find(".js-size-button.push-button--active").data("size"),
                email: email,
                code: object.data("code"),
                fw: true
            });
            thankyouDivToShow = '#thank-you-div-notifyme';
        } else {
            if (!validateInput()) return;
            email = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#email-input").val();
            data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
                size: __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#cant-find-size-ul").find(".js-size-button.push-button--active").data("size"),
                email: email,
                code: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("code"),
                fw: true
            });
            thankyouDivToShow = '#thank-you-div';
        }

        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post("/r/ajax/SubmitFindSizeInquiry.jsp", data, function (msg) {
            var result = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.parseJSON(msg);
            if (result.success) {
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#thank-you-email").html(email);
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#main-div").hide();
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()(thankyouDivToShow).show();
            } else {
                //show error message
            }
        });
    }

    function validateInput() {
        var valid = true;
        if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#instock-msg").is(":visible")) {
            valid = false;
        }
        if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#cant-find-size-ul").find(".js-size-button.push-button--active").length) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#selectsize-msg").slideDown(600);
            valid = false;
        } else {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#selectsize-msg").hide();
        }
        if (!validateEmail(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#email-input").val())) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#email-input").addClass("errortextbox");
            valid = false;
        } else {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#email-input").removeClass("errortextbox");
        }
        return valid;
    }

    function clickSize(event) {
        if (event.preventDefault) {
            event.preventDefault();
        } else {
            event.returnValue = false;
        }
        // $("#notify-me-btn").removeClass("disable").prop("disabled", false);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).closest("#cant-find-size-ul").find(".push-button--active").removeClass("push-button--active");
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass("push-button--active");
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#selectsize-msg").slideUp();
        var revolveInStock = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('revolve');
        var inStock = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("instock");
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-notification-r-in-stock').hide();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-shop-revolve-instock').hide();
        if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("instock") && !__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("preorder")) {
            //instock, not preorder
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#instock-msg").slideDown(600);
            // $("#notify-me-btn").addClass("disable").prop("disabled", true);
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".regular").hide();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".preorder").hide();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#email-input").hide();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-btn-modal").text('ADD TO BAG');
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-btn-modal").show();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#notify-me-btn").hide();
            var clickedSize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("data-size");
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-select option[value="' + clickedSize + '"]').prop('selected', true);
        } else if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("preorder")) {
            //preorder
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".preorder").show();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".regular").hide();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#instock-msg").slideUp();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#email-input").hide();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-btn-modal").text('PREORDER');
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-btn-modal").show();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#notify-me-btn").hide();
            var clickedSize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("data-size");
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-select option[value="' + clickedSize + '"]').prop('selected', true);
        } else if (!inStock && revolveInStock) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".regular").show();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".preorder").hide();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#instock-msg").slideUp();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#email-input").hide();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-btn-modal").hide();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#notify-me-btn").hide();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-notification-r-in-stock').show();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-shop-revolve-instock').show();
        } else {
            //not pre order not in stock =(out of stock)
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".regular").show();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".preorder").hide();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#instock-msg").slideUp();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#email-input").show();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-btn-modal").hide();
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#notify-me-btn").show();
        }
    }

    function emailInputKeyup() {
        var valid = false;
        if (validateEmail(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val())) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).removeClass("errortextbox");
        }
    }

    function validateEmail(emailStr) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(emailStr);
    }
    return {
        submitNotifyMe: submitNotifyMe,
        clickSize: clickSize,
        emailInputKeyup: emailInputKeyup
    };
}();

//handles all notify me requests. can't find your size and special order inquiry both.
//depending on the item quantity type(preorder, out of stock, instock, or combination), price type(sale/regular),
//and number of item sizes(mutlsize, one size)
function showNotifyMePopup(event) {
    if (event) {
        event.preventDefault ? event.preventDefault() : event.returnValue = false;
    }

    var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
        code: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("code"),
        dept: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("dept"),
        sectionURL: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("sectionurl"),
        sessionID: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("sessionid"),
        showSpecialOrder: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("showSpecialOrder"),
        showBackInStock: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("showBackInStock"),
        size: getSelectedSize(false)
    });

    //determine which page to call.
    var showSpecialOrderOnly = false;

    //console.log("$(this).data(showSpecialOrder) " + typeof $(this).data("showSpecialOrder") + " $(this).data(showBackInStock) " + typeof $(this).data("showBackInStock"));

    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("showSpecialOrder") === true && __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("showBackInStock") === false) {
        showSpecialOrderOnly = true;
    }

    if (showSpecialOrderOnly == true) {

        var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
            code: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("code"),
            dept: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("dept"),
            sectionURL: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("sectionurl"),
            sessionID: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("sessionid"),
            size: getSelectedSize(false)
        });

        var initSpecialOrderPopup = function initSpecialOrderPopup() {
            //bind events here
            // window.addToBag = addToBag;
            // window.closePopup = closePopup;
            // window.enableSpecialOrder = enableSpecialOrder;
            // window.disableNotifyMe = disableNotifyMe;

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#special-order-sizes button").click(clickSpecialOrderSize);

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#special-order-btn").click(submitSpecialOrderOrNotifyMe);
            //$("#special-order-btn").click(submitSpecialOrder);

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".close-popup").click(closePopup);
        };

        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
            url: "/fw/dialog/SpecialOrder.jsp",
            data: data,
            triggerOpen: true,
            scrolling: false,
            type: 'small',
            onComplete: function onComplete() {
                if (typeof initSpecialOrderPopup === 'function') {
                    initSpecialOrderPopup();
                }
            }
        });
    } else {
        var initPopup = function initPopup() {
            //bind events here
            // window.addToBag = addToBag;
            // window.closePopup = closePopup;
            // window.enableSpecialOrder = enableSpecialOrder;
            // window.disableNotifyMe = disableNotifyMe;

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#cant-find-size-ul a").click(backInStockUtils.clickSize);

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#notify-me-btn").click(backInStockUtils.submitNotifyMe);

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".close-popup").click(closePopup);

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#email-input").keyup(backInStockUtils.emailInputKeyup);

            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#popup-show-special-order").click(showSpecialOrderPopup);
        };

        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
            url: "/fw/dialog/CantFindYourSize.jsp",
            data: data,
            triggerOpen: true,
            scrolling: false,
            type: 'small',
            onComplete: function onComplete() {
                initPopup();
                __WEBPACK_IMPORTED_MODULE_0_jquery___default()("ul#cant-find-size-ul .push-button--active").click();
            }
        });
    }
}

function showSizeGuidePopup() {
    var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
        "measurements": __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size_and_fit_link").data("measurements"),
        "measuretable": __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size_and_fit_link").data("measuretable"),
        "international": __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size_and_fit_link").data("international"),
        "bullets": __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size_and_fit_link").data("bullets")
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
        url: __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#size_and_fit_link").data("url"),
        data: data,
        triggerOpen: true,
        onComplete: function onComplete() {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".sizeguide_measurement").click(convertSize);
        }
    });
}

function closePopup(event) {
    if (event) {
        event.preventDefault ? event.preventDefault() : event.returnValue = false;
    }
}

function enableSpecialOrder() {
    var btn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#special-order-btn");
    btn.prop("disabled", false).css("opacity", "1");
}

function disableSpecialOrder() {
    var btn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#special-order-btn");
    btn.prop("disabled", true).css("opacity", "0.5");
}

function enableNotifyMe() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#notEligibleForSpecialOrder").show();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#is-place-order-div").hide();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#special-order-comment").hide();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#special-order-btn").val("Notify Me");
}

function disableNotifyMe() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#notEligibleForSpecialOrder").hide();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#is-place-order-div").show();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#special-order-comment").show();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#special-order-btn").val("Submit Special Order");
}

function clickSpecialOrderSize(event) {
    event.preventDefault ? event.preventDefault() : event.returnValue = false;

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).closest("#special-order-sizes").find('.action-button--active').removeClass("action-button--active");
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass("action-button--active");
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#so-select-size-error").removeClass("u-error");
    var size = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("data-size");
    var canSpecialOrder = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("data-can-special-order");
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#regular_so_msg").show();
    var revolveInStock = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('revolve');
    var inStock = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("isInstock");
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-notification-r-in-stock').hide();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-shop-revolve-instock').hide();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".spl-ord-works").show();

    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("isInstock") || __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("preorder")) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#regular_so_msg").hide();
        //disable button
        if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("preorder")) {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#instock-msg").text("Currently available for preorder");
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-btn-so-modal").text('PREORDER');
        } else {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#instock-msg").text("Currently in stock");
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-btn-so-modal").text('ADD TO BAG');
        }
        var clickedSize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr("data-size");
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#size-select option[value="' + clickedSize + '"]').prop('selected', true);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-btn-so-modal").show();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#specialOrderForm").hide();

        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#instock-msg").slideDown(600);
        disableSpecialOrder();
        disableNotifyMe();
    } else if (!inStock && revolveInStock) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#instock-msg").hide();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-btn-so-modal").hide();
        disableNotifyMe();
        disableSpecialOrder();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".spl-ord-works").hide();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-notification-r-in-stock').show();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-shop-revolve-instock').show();
    } else if (canSpecialOrder == "false") {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-btn-so-modal").hide();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#specialOrderForm").show();
        enableSpecialOrder();
        enableNotifyMe();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#instock-msg").hide();
    } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#add-to-bag-btn-so-modal").hide();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#specialOrderForm").show();
        //enable button
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#instock-msg").slideUp(600);
        enableSpecialOrder();
        disableNotifyMe();
    }
}

function submitSpecialOrderOrNotifyMe() {
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#special-order-btn").val() == "Submit Special Order") submitSpecialOrder.apply(this);else if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#special-order-btn").val() == "Notify Me") backInStockUtils.submitNotifyMe(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#special-order-btn"), false);
}

function submitSpecialOrder() {
    var size = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#special-order-sizes .js-size-button.action-button--active").attr("data-size");
    if (!size) {
        //add pleace select size alert
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#so-select-size-error").addClass("u-error");
        return;
    } else {
        //remove select size alert
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#so-select-size-error").removeClass("u-error");
    }
    var email = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#special-order-email").val();
    if (!email) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#special-order-email").addClass("errortextbox");
        return;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#special-order-email").removeClass("errortextbox");
    }

    var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
        SOProductCode: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("code"),
        SOSectionURL: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("sectionurl"),
        SOSessionID: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("sessionid"),
        SOSize: size,
        SOUserEmail: email,
        SOAutoOrder: __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#is-place-order-div").find("input:checked").val(),
        SOComment: __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#special-order-comment").val()
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post("/fw/SubmitSpecialOrderInquiry.jsp", data, function () {
        showConfirmPopup();
    });
}

function showConfirmPopup() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#main-div").hide();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#thank-you-div").show();
}

function closePopup2(event) {
    closePopup(event);
}

function convertSize() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".sizeguide_measurement").removeClass("active");
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass("active");

    //console.log($(this).text());
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).text() == "IN") {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".sizeToConvertInch").show();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".sizeToConvertCM").hide();
    } else {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".sizeToConvertCM").show();
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".sizeToConvertInch").hide();
    }
}

window.enableSpecialOrder = function () {
    enableSpecialOrder();
};

window.disableSpecialOrder = function () {
    disableSpecialOrder();
};

window.enableNotifyMe = function () {
    enableNotifyMe();
};

window.disableNotifyMe = function () {
    disableNotifyMe();
};

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
    showBagSyncNotifications();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-select-size').sizeSelectionModal();

    setupViewShippingOptions();

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".remove_wish_list").click(removeWishListItem);

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.close-popup').click(closePopup);

    bindEvents();

    window.loadForwardMultipleQuickView = loadForwardMultipleQuickView;
    window.addToBagFromWishList = addToBagFromWishList;
    window.addToBagFromCarouselItem = addToBagFromCarouselItem;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__modules_social_proof__["b" /* renderCartSocialProof */])(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.item_row').toArray().map(function (el) {
        return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).data('code');
    }));
});

/***/ })

},[155]);


// WEBPACK FOOTER //
// dist/shoppingbag.js